export const SpreadMonitoringPermissions = {
  default: 'User.RiskMonitoring.SpreadMonitoring',
  liveTab: 'User.RiskMonitoring.SpreadMonitoring.LiveSpreadTab',
  historicalTab: 'User.RiskMonitoring.SpreadMonitoring.HistoricalSpreadTab',
} as const;
